import { Image } from 'components/Image/Image';
import WebPlusOverviewBannerView from './WebPlusOverviewBannerView';
import MobilePlusOverviewBannerView from './MobilePlusOverviewBannerView';

export const PlusOverviewBannerModuleView = props => {
  const { isTwoModules } = props;
  return (
    <>
      <Image imgClass="sesamePlusTag pos-abs top0 right0" />
      {!isTwoModules && <WebPlusOverviewBannerView {...props} />}
      <MobilePlusOverviewBannerView {...props} isTwoModules={isTwoModules} />
    </>
  );
};
